module.exports = __webpack_public_path__ + "static/img/goods-list-img04.1e61dd85.svg";